import { render, staticRenderFns } from "./AIAFootMenu.vue?vue&type=template&id=a910410a&scoped=true&"
import script from "./AIAFootMenu.vue?vue&type=script&lang=js&"
export * from "./AIAFootMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a910410a",
  null
  
)

export default component.exports